module.exports = __webpack_public_path__ + "img/emoji_xihuan.b16fa606.png";